"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppletStates = void 0;
/**
 * All available applet states
 * @enum
 */
const AppletStates = {
  /** The applet is registered but no state has been set */
  UNKNOWN: 'unknown',
  /** The applet is actively loading data */
  LOADING: 'loading',
  /** The applet is not in an idle state */
  COMPLETE: 'complete',
  /**
   * Check whether the provided string is a valid AppletStates value
   * @param {string} maybeAppletState - Possible AppletStates value to validate
   * @returns {boolean} - true if it is a valid AppletStates value, false otherwise
   */
  isValid: function (maybeAppletState) {
    return Object.values(AppletStates).includes(maybeAppletState);
  }
};
exports.AppletStates = AppletStates;